/**
 * La sortie d'un salarié — motifs et libellés (09/08).
 *
 * Décision de Théo du 28/07 : « date + motif de sortie à ajouter sur la fiche ».
 *
 * UNE SORTIE NE SUPPRIME RIEN. Elle retire le salarié des compteurs de
 * conformité actifs (cartes pro, DPAE, profils incomplets) ; sa fiche, ses
 * contrats et ses bulletins restent consultables — la loi impose de les
 * conserver, et on ne détruit jamais une preuve.
 *
 * Jumeau Python : `MOTIFS_SORTIE` dans `backend/utils/sortie_fiche.py`, avec un
 * test qui compare les deux listes.
 */

export const MOTIFS_SORTIE = [
  { code: 'fin_cdd', label: 'Fin de CDD' },
  { code: 'demission', label: 'Démission' },
  { code: 'rupture_periode_essai', label: "Rupture de période d'essai" },
  { code: 'rupture_conventionnelle', label: 'Rupture conventionnelle' },
  { code: 'licenciement', label: 'Licenciement' },
  { code: 'abandon_poste', label: 'Abandon de poste' },
  { code: 'retraite', label: 'Départ à la retraite' },
  { code: 'deces', label: 'Décès' },
  { code: 'autre', label: 'Autre' },
];

/** Libellé d'un motif. Un code inconnu se rend tel quel — on n'efface pas
 *  une saisie qu'on ne reconnaît pas. */
export const libelleMotifSortie = (code) =>
  MOTIFS_SORTIE.find((m) => m.code === code)?.label || code || '';

/**
 * Ce salarié a-t-il quitté les effectifs ?
 *
 * Même règle que le backend (`data_gaps_service.salarie_est_sorti`, juge unique de
 * utils/juges) : une sortie ANNONCÉE pour plus tard ne retire personne — le salarié
 * est encore là.
 *
 * 26/10/2026 (suivi RH, lot 2) : quand le serveur sert la réponse du juge
 * (`est_sorti`, GET /api/employees), c'est ELLE qui fait foi ; le calcul ci-dessous
 * n'est qu'un repli. Et le repli compte désormais `CDD_SORTI` comme le juge
 * (règle de Théo du 12/09 : un CDD dont la date de fin est dépassée est SORTI) —
 * avant, le badge disait « présent » un CDD fini que tous les compteurs disaient parti.
 */
export const STATUTS_SORTIS = ['CDI_SORTI', 'CDD_SORTI'];

export const estSorti = (fiche) => {
  if (typeof fiche?.est_sorti === 'boolean') return fiche.est_sorti;
  if (fiche?.ex_salarie === true) return true;
  // 27/08 : une fiche statuée CDI_SORTI est sortie même sans date lisible ;
  // 12/09 : CDD_SORTI aussi (statut posé chaque nuit par le réconciliateur).
  if (STATUTS_SORTIS.includes(fiche?.statut_contrat)) return true;
  const d = (fiche?.date_sortie || '').toString().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return false;
  return d <= new Date().toISOString().slice(0, 10);
};
